import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useExchangeRate } from '../ExchangeRateContext';

export default function RateModal({ show, onClose }) {
  const { token, user } = useAuth();
  const { refresh } = useExchangeRate();
  const [useCentralBank, setUseCentralBank] = useState(true);
  const [manualRate, setManualRate] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!show) return;
    (async () => {
      try {
        setError(null);
        const headers = {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
          ...(user?.ownerId ? { 'x-owner-id': String(user.ownerId) } : {}),
          ...(user?.staffId ? { 'x-staff-id': String(user.staffId) } : {})
        };
        const res = await fetch('/api/exchange-rates', { headers });
        if (!res.ok) throw new Error('Failed to fetch');
        const data = await res.json();
        setUseCentralBank(Boolean(data.useCentralBank));
        if (data.rate) {
          setManualRate(String(data.rate)); // prefill with current rate always
        }
      } catch (e) {
        setError(e.message);
      }
    })();
  }, [show, token, user?.ownerId, user?.staffId]);

  const applyCentralBank = async () => {
    try {
      setLoading(true);
      setError(null);
      const headers = {
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        ...(user?.ownerId ? { 'x-owner-id': String(user.ownerId) } : {}),
        ...(user?.staffId ? { 'x-staff-id': String(user.staffId) } : {})
      };
      const res = await fetch('/api/exchange-rates', {
        method: 'PUT',
        headers,
        body: JSON.stringify({ useCentralBank: true })
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || 'Failed to switch to central bank rate');
      }
      await refresh?.();
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const onToggleSwitch = async (e) => {
    const checked = e.target.checked;
    setUseCentralBank(checked);
    if (checked) {
      await applyCentralBank();
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const value = Number(manualRate);
    if (!Number.isFinite(value) || value <= 0) {
      setError('Please enter a valid rate');
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const headers = {
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        ...(user?.ownerId ? { 'x-owner-id': String(user.ownerId) } : {}),
        ...(user?.staffId ? { 'x-staff-id': String(user.staffId) } : {})
      };
      const res = await fetch('/api/exchange-rates', {
        method: 'PUT',
        headers,
        body: JSON.stringify({ useCentralBank: false, rate: value })
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || 'Failed to set manual rate');
      }
      await refresh?.();
      onClose?.();
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Almashuv kursi</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>
          <form onSubmit={onSubmit}>
            <div className="modal-body">
              {error && <div className="alert alert-danger" role="alert">{error}</div>}

              <div className="form-check form-switch mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="useCentralBankSwitch"
                  checked={useCentralBank}
                  onChange={onToggleSwitch}
                  disabled={loading}
                />
                <label className="form-check-label" htmlFor="useCentralBankSwitch">
                  Markaziy bank kursidan foydalanish
                </label>
              </div>

              <div className="mb-3">
                <label htmlFor="manualRate" className="form-label">Kurs (UZS)</label>
                <input
                  type="number"
                  step="0.001"
                  className="form-control"
                  id="manualRate"
                  placeholder="Masalan: 12750"
                  value={manualRate}
                  onChange={(e) => setManualRate(e.target.value)}
                  disabled={useCentralBank || loading}
                />
                <div className="form-text">O'chirilsa, o'zingiz xohlagan kursni kiriting.</div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>Yopish</button>
              <button type="submit" className="btn btn-primary" disabled={useCentralBank || loading || !manualRate}>Saqlash</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}


